// Copyright (c) 2016 Deere & Company

import MassChannelCustomerFollowUp from '@deere/cps-it.warranty-model-factory/lib/mass-channel-customer-follow-up';
import t from 'tcomb';

const Report = t.list(MassChannelCustomerFollowUp, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/mass-channel-customer-follow-up/state/report.js